/**
 * FastAPI `property_name` expects the human name only (e.g. "FFI Albany, GA"), not "CODE - Name".
 * UI Autocomplete labels use "{propertyCode} - {propertyName}" for display only.
 */
export function propertyDisplayNameForApi(prop) {
  if (!prop || prop.propertyName == null || !String(prop.propertyName).trim()) {
    return null;
  }
  let name = String(prop.propertyName).trim();
  const code =
    prop.propertyCode != null
      ? String(prop.propertyCode).trim()
      : prop.PROPERTY_CODE != null
        ? String(prop.PROPERTY_CODE).trim()
        : '';
  if (code) {
    const escaped = code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    name = name.replace(new RegExp(`^${escaped}\\s*-\\s*`, 'i'), '').trim();
  }

  const sep = ' - ';
  const i = name.indexOf(sep);
  if (i > 0) {
    const prefix = name.slice(0, i).trim();
    const suffix = name.slice(i + sep.length).trim();
    const prefixLooksLikeCode =
      suffix &&
      !/\s/.test(prefix) &&
      prefix.length >= 2 &&
      prefix.length <= 32 &&
      /^[\w.-]+$/.test(prefix) &&
      /\d/.test(prefix);
    if (prefixLooksLikeCode) {
      return suffix;
    }
  }

  return name || null;
}

/** Resolve property row from list by stored hotel filter value (name only, not display label). */
export function findPropertyByHotelSelection(properties, hotelSelection) {
  if (!hotelSelection || !Array.isArray(properties)) return null;
  const needle = String(hotelSelection).trim();
  return (
    properties.find(
      (p) =>
        String(p.PROPERTY_NAME || p.propertyName || '').trim() === needle ||
        String(p.propertyName || '').trim() === needle
    ) || null
  );
}

/**
 * Name to pass as FastAPI `property_name` from a hotel filter value + optional properties list.
 */
export function propertyNameQueryForFastApi(hotelSelection, properties = []) {
  if (!hotelSelection || !String(hotelSelection).trim()) return null;
  const selected = findPropertyByHotelSelection(properties, hotelSelection);
  if (selected) {
    return propertyDisplayNameForApi(selected);
  }
  return propertyDisplayNameForApi({ propertyName: hotelSelection });
}

/** Bank statement APIs expect six leading zeros (e.g. 000000707132786). */
export function bankAccountNumberForApiQuery(bankAccountNo) {
  const trimmed = String(bankAccountNo ?? '').trim();
  if (!trimmed) return '';
  const core = trimmed.replace(/^0+/, '') || trimmed;
  return `000000${core}`;
}
